// Import model
import { ContactCondition } from '../models/ContactCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { ContactIndexedFields } from '../models/ContactIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { ContactIndexedFieldsSerializer } from './ContactIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ContactCondition - handles JSON serialization and deserialization with type validation
 */
export class ContactConditionSerializer {
  /**
   * Deserializes a JSON string into a ContactCondition instance
   */
  static deserialize(json: string): ContactCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ContactCondition instance
   */
  static fromObject(obj: any): ContactCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ContactCondition');
    }


    const instance: ContactCondition = {
      fieldName: obj['fieldName'] as ContactIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ContactCondition instances
   */
  static deserializeArray(json: string): ContactCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ContactCondition instance to a JSON string
   */
  static serialize(instance: ContactCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ContactCondition instance to a plain object
   */
  static toObject(instance: ContactCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of ContactCondition instances to a JSON string
   */
  static serializeArray(instances: ContactCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
